import { useEffect, useState, useRef } from "react";
import { Card, Stack } from "react-bootstrap";
import { CardTitle } from "../components/card_components";
import TableWrapper from "@/components/Table/TableWrapper";
import upcomingInstallmentsSchema from "@/components/Table/schemas/upcoming_installments";
import { getRepaymentSchedule } from "@/services/loanservices";

const BATCH_SIZE = 10;

export default function UpcomingInstallments({ loanUUID }) {
  const [fullInstallments, setFullInstallments] = useState([]);
  const [displayedInstallments, setDisplayedInstallments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const tableContainerRef = useRef();

  useEffect(() => {
    if (loanUUID) loadInstallments();
  }, [loanUUID]);

  const loadInstallments = async () => {
    try {
      const repaymentRes = await getRepaymentSchedule(loanUUID);
      const amortization = repaymentRes?.results?.response?.data?.amortization || [];

      const mappedData = amortization.map(item => ({
        amount: item.installmentAmount,
        dueDate: item.emiDate,
        principal: item.principalAmount,
        interest: item.interestAmount,
        status: item.paymentStatus
      }));

      setFullInstallments(mappedData);
      setDisplayedInstallments(mappedData.slice(0, BATCH_SIZE));
    } catch (err) {
      console.error("Failed to fetch installments:", err);
      setError(err?.message || "Failed to load installments");
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    const container = tableContainerRef.current;
    if (!container) return;
    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 5) {
      const currentLength = displayedInstallments.length;
      if (currentLength >= fullInstallments.length) return;
      setDisplayedInstallments(prev => [
        ...prev,
        ...fullInstallments.slice(currentLength, currentLength + BATCH_SIZE),
      ]);
    }
  };

  if (loading) return <div>Loading installments...</div>;
  if (error) return <div className="text-danger">{error}</div>;
  if (!fullInstallments.length) return <div>No installments available</div>;

  return (
    <Card className="border-0 rounded-lg">
      <Card.Body>
        <Stack gap={2}>
          <Card.Title>
            <Stack direction="horizontal">
              <CardTitle title="Repayment Schedule" csx="me-auto" />
            </Stack>
          </Card.Title>
        </Stack>

        <div
          ref={tableContainerRef}
          style={{ maxHeight: 400, overflowY: "auto" }}
          onScroll={handleScroll}
        >
          <TableWrapper
            columnSchema={upcomingInstallmentsSchema}
            tableData={displayedInstallments}
          />
        </div>
      </Card.Body>
    </Card>
  );
}
